import { create } from 'mobx-persist';

// Explicitly use localStorage so login state persists across page refresh
const storage = typeof window !== 'undefined' ? window.localStorage : undefined;

export const hydrateMobX = create({
  debounce: 500,
  ...(storage && { storage }),
});
